// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h5[font*=secondary] {
  font-family: var(--font-secondary);
}`, "",{"version":3,"sources":["webpack://./src/app/popovers/loyalty/loyalty.component.scss"],"names":[],"mappings":"AACI;EACE,kCAAA;AAAN","sourcesContent":["h5 {\r\n    &[font*='secondary'] {\r\n      font-family: var(--font-secondary);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
